module.exports = __webpack_public_path__ + "img/image_9.35df16d9.jpg";